import { EstimateAddOnsSection } from '@/components/public/EstimateAddOnsSection';
import { fmt, useQuoteActions } from '../quoteActionContext';

// Optional add-ons — shared with the portal estimate surface. The customer's
// live toggles drive the selection engine's reprice, so the money the rest of
// the page shows tracks whatever is ticked here.
export function OptionalSelectionSlot() {
  const {
    estimate,
    presentation,
    displayOptionalOffers,
    optionalSelections,
    toggleOptional,
    canAct,
    depositSelectionLocked,
    membershipOffer,
    acceptMembershipOffer,
    v,
  } = useQuoteActions();
  return (
    <>
      {depositSelectionLocked && displayOptionalOffers.length > 0 ? (
        <p className="mt-6 rounded-md border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-600">
          Your deposit was priced on the extras selected below, so they can no longer be changed
          here — ask for a revised estimate to add one.
        </p>
      ) : null}
      <EstimateAddOnsSection
        variant={presentation === 'SINGLE_SCOPE' ? 'single-scope' : 'default'}
        offers={displayOptionalOffers}
        optionalSelections={optionalSelections}
        toggleOptional={toggleOptional}
        canAct={canAct && !depositSelectionLocked}
        fmt={fmt}
        membershipOffer={membershipOffer}
        allLines={estimate.lineItems}
        useMemberPricing={acceptMembershipOffer}
        showDescription={v.itemDescriptions}
        showImage={presentation === 'SINGLE_SCOPE' && v.itemImages}
        showQuantity={v.quantities}
        showUnitPrice={v.unitPrices}
      />
    </>
  );
}
